module.exports = "/work-site/img/power.9f818fa9.png";